module.exports = __webpack_public_path__ + "static/media/wallet_missing.a42cff13.svg";